import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=26767312&lang=css"

const __exports__ = script;

export default __exports__